import { render, staticRenderFns } from "./videozw.vue?vue&type=template&id=521a946c&scoped=true&"
import script from "./videozw.vue?vue&type=script&lang=js&"
export * from "./videozw.vue?vue&type=script&lang=js&"
import style0 from "./videozw.vue?vue&type=style&index=0&id=521a946c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a946c",
  null
  
)

export default component.exports